<template>
  <PromptBar :show-progress-bar="false">
    <template #icon>
      <FriedIcon icon="info-circle" class="icon" />
    </template>
    <template #title>{{ $t('document-has-been-modified') }}</template>
    <template #description>
      {{ $t('reload-to-see-the-updates') }}
    </template>
    <template #button-container>
      <FriedButton data-external="signing-page-snackbar-reload-button" @click="$emit('click')">
        {{ $t('see-updated-version') }}
      </FriedButton>
    </template>
  </PromptBar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PromptBar from '@getaccept/lib-shared-new/src/prompt-bar/PromptBar.vue';

export default defineComponent({
  components: {
    PromptBar,
  },
  emits: ['click'],
});
</script>
